import "core-js/modules/es.string.small.js";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React from "react";
import { useTheme, useMediaQuery, RaiseButton, IconConstants, ButtonVariantEnum, ButtonSizeEnum } from "componentLibrary";
import { jsx as _jsx } from "react/jsx-runtime";
var FilterButton = function FilterButton(_ref) {
  var _context;
  var filterCount = _ref.filterCount,
    handleFilterClick = _ref.handleFilterClick,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$useIconOnly = _ref.useIconOnly,
    useIconOnly = _ref$useIconOnly === void 0 ? false : _ref$useIconOnly,
    _ref$isSmall = _ref.isSmall,
    isSmall = _ref$isSmall === void 0 ? null : _ref$isSmall;
  var theme = useTheme();
  var isDesktopOrUp = useMediaQuery(theme.breakpoints.up("md"));
  var filterLabel = useIconOnly || !isDesktopOrUp ? "" : "Filter";
  if (isSmall !== null) {
    filterLabel = isSmall ? "" : "Filter";
  }
  var filterCountLabel = filterCount > 0 ? _concatInstanceProperty(_context = "".concat(filterLabel, " (")).call(_context, filterCount, ")") : filterLabel;
  return /*#__PURE__*/_jsx(RaiseButton, {
    size: ButtonSizeEnum.small,
    variant: ButtonVariantEnum.secondary,
    leadingIcon: IconConstants.FILTER,
    disabled: disabled,
    onClick: function onClick() {
      handleFilterClick();
    },
    children: filterCountLabel
  });
};
export default FilterButton;